import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { CurrentTimeIndicator } from './current-time-indicator';
import { GroupBody } from './group-body';
import { GroupHeader } from './group-header';
import { GroupHourLines } from './group-hour-lines';

export const ColumnGroupSections = () => {
  const groupIds = useCalendarGridStore((s) => s.groupIds);
  if (!groupIds.length) return null;

  return groupIds.map((groupId, index) => <ColumnGroupSection key={groupId} groupId={groupId} groupIndex={index} />);
};

const ColumnGroupSection = ({ groupId, groupIndex }: { groupId: string; groupIndex: number }) => {
  const { hasMultipleGroups, headerType, columnBodyVariant } = useCalendarGridStore([
    'hasMultipleGroups',
    'headerType',
    'columnBodyVariant',
  ]);
  const groupInfo = useCalendarGridStore((s) => s.groupsById[groupId]);
  const columnCount = groupInfo?.columnIds?.length;

  if (!columnCount) return null;

  const startColumn = groupIndex + groupInfo.groupOffset + 2; // +1 for time labels, +1 for 1-based grid
  const gridColumn = `${startColumn} / span ${columnCount}`;

  return (
    <>
      <GroupHeader
        gridColumn={gridColumn}
        groupInfo={groupInfo}
        isGroupHeaderVisible={hasMultipleGroups}
        headerType={headerType}
      />
      <GroupBody startColumn={startColumn} columnIds={groupInfo.columnIds} columnBodyVariant={columnBodyVariant} />
      <GroupHourLines gridColumn={gridColumn} />
      <CurrentTimeIndicator gridColumn={gridColumn} currentTime={groupInfo.currentTime} />
    </>
  );
};
